import React from "react";

import RolesList from "../component/RolesList"; 

const RolesListContainer = ({ pageId }) => (<RolesList pageId={pageId}/>)

export default RolesListContainer;